export enum SalesTaxTabIndex {
  TaxAuthorities = 0,
  Categories = 1
}
